import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApplicationService } from '../application/application.service';

@Injectable()
export class NavigationService {
  activeApplicationSection$: BehaviorSubject<number>;
  afterActiveSectionLoaded$: BehaviorSubject<number>;
  previousSection: number = -1;
  currentSection: number = -1;

  constructor(protected applicationService: ApplicationService) {
    this.afterActiveSectionLoaded$ = new BehaviorSubject(0);
    this.activeApplicationSection$ = new BehaviorSubject(0);
    this.activeApplicationSection$.subscribe((section) => {
      this.previousSection = this.currentSection;
      this.currentSection = section;
    });
  }
}
